export const ICON_ALIASES = {
  arrowLeft: 'arrowLeft',
  arrowRight: 'arrowRight',
  arrowDownCircle: 'arrowDownCircle',
  closeSquare: 'closeSquare',
  document: 'document',
  tick: 'tick',
  tickSquare: 'tickSquare',
  link: 'link',
  chevronDown: 'chevronDown',
  chevronUp: 'chevronUp',
  category: 'category',
  moneySend: 'moneySend',
  moneyReceive: 'moneyReceive',
  receipt: 'receipt',
  receiptDiscount: 'receiptDiscount',
  call: 'call',
  calling: 'calling',
  sms: 'sms',
  edit: 'edit',
  documentEdit: 'documentEdit',
  growth: 'growth',
  drop: 'drop',
  checkbox: 'checkbox',
  checkboxFilled: 'checkboxFilled',
  home: 'home',
  rateUp: 'rateUp',
  rateDown: 'rateDown',
  calendar: 'calendar',
  documentText: 'documentText',
  archiveTick: 'archiveTick',
  star: 'star',
  profileCircle: 'profileCircle',
  users: 'users',
  documentNormal: 'documentNormal',
  profileTick: 'profileTick',
  eye: 'eye',
  eyeSlash: 'eyeSlash',
  close: 'close',
  dollarSquare: 'dollarSquare',
  card: 'card',
  cardSend: 'cardSend',
  cardReceive: 'cardReceive',
  amex: 'amex',
  discover: 'discover',
  mastercard: 'mastercard',
  visa: 'visa',
  testcard: 'testcard',
  plus: 'plus',
  tickCircle: 'tickCircle',
  tickCircleFilled: 'tickCircleFilled',
  infoCircle: 'infoCircle',
  slash: 'slash',
  trash: 'trash',
  radioOn: 'radioOn',
  radioOff: 'radioOff',
  message: 'message',
};
